import { render, staticRenderFns } from "./descending.vue?vue&type=template&id=a01be81c&scoped=true&"
import script from "./descending.vue?vue&type=script&lang=js&"
export * from "./descending.vue?vue&type=script&lang=js&"
import style0 from "./descending.vue?vue&type=style&index=0&id=a01be81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01be81c",
  null
  
)

export default component.exports